export default "2fd4e214797fc703.woff2"